import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import queryString from 'query-string';
import { subscribe } from 'alfa';

import UserRepo from '../../repository/user';
import Security from '../../helpers/security';

class LoginConfirm extends Component { // eslint-disable-line fp/no-class
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    this.getUser();
  }

  getUser = async () => {
    const { user, location: { search } } = this.props;
    const values = queryString.parse(search);
    values.seed = Security.getAuthseed();
    try {
      const { data: { user: fetchedUser, token: fetchedToken } } = await UserRepo.authConfirm(values);
      Security.registerUser(JSON.stringify(fetchedUser));
      Security.registerToken(btoa(JSON.stringify(fetchedToken)));
      Security.unregisterAuthSeed();
      user.setData(fetchedUser);
    } catch (error) {
      console.error('ERROR: LoginConfirm: UserRepo.authConfirm()', error); // eslint-disable-line no-console
    } finally {
      this.setState({
        loading: false,
      });
    }
  }

  render() {
    if (this.state.loading) {
      return 'loading...';
    }

    return <Redirect to="/" />;
  }
}

LoginConfirm.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.object,
  }),
  user: PropTypes.shape({
    setData: PropTypes.func,
  }),
};

export default subscribe(LoginConfirm, ['set', 'user'], ['user']);
